import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/doc-with-checkmark.svg'
import _imports_1 from '@/assets/images/docusign-REI.png'


const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "controls" }
const _hoisted_3 = {
  key: 0,
  class: "docusign-rei-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.close,
    classes: 'completed-res-form'
  }, _createSlots({ _: 2 }, [
    (!$setup.loading)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-body" }, [
                _createElementVNode("div", { class: "description" }, [
                  _createElementVNode("img", {
                    class: "doc-image",
                    src: _imports_0,
                    alt: "doc-with-checkmark"
                  }),
                  _createElementVNode("h2", null, "You’ve approved the completed contract form!")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_2, [
                ($props.isDocusignEnabled)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.generate()))
                    }, "Generate Contract"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "button primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.share()))
                }, "Share Form"),
                _createElementVNode("button", {
                  class: "button primary outline",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.getSalesAdviceDocument()))
                }, "Download")
              ]),
              (!$props.isDocusignEnabled && !$setup.isRequestAccessEmailSent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", { class: "docusign-rei-row" }, [
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "docusign-rei-column" }, [
                        _createElementVNode("div", { class: "badge integration-badge" }, "INTEGRATION"),
                        _createElementVNode("img", {
                          class: "docusign-rei-img",
                          src: _imports_1,
                          alt: "docusign-rei"
                        })
                      ], -1)),
                      _createElementVNode("div", { class: "docusign-rei-column--text" }, [
                        _cache[3] || (_cache[3] = _createElementVNode("p", null, "Generate and auto-populate contracts with a few clicks, review then send out for signature.", -1)),
                        _createElementVNode("button", {
                          class: "button primary",
                          onClick: $setup.requestDocusignAccess
                        }, "Request access")
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          key: "0"
        }
      : {
          name: "content",
          fn: _withCtx(() => [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal-body" }, [
              _createElementVNode("div", { class: "spinner" })
            ], -1))
          ]),
          key: "1"
        }
  ]), 1032, ["isOpen"]))
}